import { IVisualInventoryDto } from "../../models/dto/agendaApi/IVisualInventoryDto";
import * as ApiWithToken from "../callApiWithToken";

const visualInventoryService = {
    getBrands: async function (includedHp: Boolean, appointmentId: number) {
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `VisualInventories/getBrands?includedHp=${includedHp}&appointmentId=${appointmentId}`);
    },
    getMaterialInventory: async function (languageId: number) {
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `VisualInventories/getMaterialInventory?languageId=${languageId}`);
    },
    insertVisualInventory: async function (visualInventory: IVisualInventoryDto[]) {
        return ApiWithToken.postApi(process.env.REACT_APP_AGENDAS_API + `VisualInventories/insertVisualInventory`, visualInventory);
    }
}

export default visualInventoryService;